// Single source of truth for per-day coloring. Used by both the map
// (marker fills, polylines, cluster count) and the timeline (card
// number badge, day-header strip) so the two can never drift and a
// reader can match a card to a marker at a glance.
export const DAY_COLORS = [
  "#2563eb",
  "#dc2626",
  "#16a34a",
  "#ca8a04",
  "#9333ea",
  "#0891b2",
  "#e11d48",
  "#64748b",
];

export function dayColor(dayNumber: number): string {
  if (!dayNumber || dayNumber < 1) return DAY_COLORS[0];
  return DAY_COLORS[(dayNumber - 1) % DAY_COLORS.length];
}
